export const API_VERSION = "v2";

const SESSION_CREATION_PATH = "/auth/session";
const SESSION_RECOVERY_PATH = "/auth/session-recovery/sessions";
const API_SESSION_CREATION_PATH = `/api${SESSION_CREATION_PATH}`;
const API_SESSION_RECOVERY_PATH = `/api${SESSION_RECOVERY_PATH}`;

const getFallbackOrigin = () =>
  typeof window !== "undefined" ? window.location.origin : "http://localhost";

const getPathname = (url?: string): string => {
  if (!url) return "";

  try {
    return new URL(url, getFallbackOrigin()).pathname;
  } catch (_error) {
    return url.split("?")[0] ?? "";
  }
};

const isPathOrChild = (pathname: string, parent: string): boolean =>
  pathname === parent || pathname.startsWith(`${parent}/`);

export const getSessionRecoveryPath = (nodeEnv = process.env.NODE_ENV): string =>
  nodeEnv === "development" ? API_SESSION_RECOVERY_PATH : SESSION_RECOVERY_PATH;

export const shouldAttachBackendSession = (url?: string): boolean => {
  const pathname = getPathname(url);
  if (!pathname) return true;

  if (pathname === SESSION_CREATION_PATH || pathname === API_SESSION_CREATION_PATH) {
    return false;
  }

  if (
    isPathOrChild(pathname, SESSION_RECOVERY_PATH) ||
    isPathOrChild(pathname, API_SESSION_RECOVERY_PATH)
  ) {
    return false;
  }

  return true;
};
